const MobileRecognitionPointsExceptionView = () => {
  return 'PointsExceptionView'
}

export default MobileRecognitionPointsExceptionView
